<div class="signin-content" *ngIf="vm$ | async as vm">
  <mat-card class="signin-card" appearance="outlined">
    <div class="signin-card__logo">
      <div class="login-logo" [style.background-image]="'url(' + logoUrl + ')'" ></div>
    </div>
    <div class="signin-card__body">
      <div id="api"></div>
      <div class="btn_login">
        <button class="btn_login" (click)="handlePrimaryAction()"
          [disabled]="vm.isCallingApi || vm.disableLoginButton">
          <span class="btn_login__label">
            {{ getPrimaryButtonLabel(vm) }}
          </span>
        </button>
      </div>
    </div>
    <div class="signin-card__alt" *ngIf="vm.isAuthenticated">
      <button type="button" (click)="loginWithDifferentAccount()">{{ loginWithDifferentAccountLabel }}</button>
    </div>
  </mat-card>

  <footer class="login-footer">
    <div class="login-footer__text">
      &#169; <span class="year">{{year}}</span> - PLIMES Inc. All rights reserved.
    </div>
  </footer>
</div>
